import { Link } from 'react-router-dom';

const MobileAduhAddress = () => {
  return (
    <Link to="/aduh/lokasi">
      <p style={{ lineHeight: '1.1', fontSize: '20px' }}>
        <br/>
        LOKASI<br />
        <span style={{ fontSize: '15px'}}>(5 menit jalan kaki dari Pintu Keluar A Kowloon Bay)</span><br/>
        1101 KINGSFORD INDUSTRIAL CENTRE,<br/>
        13 WANG HOI ROAD, KOWLOON BAY<br /><br/>
        JAM BUKA<br/>
        10 pagi ~ 7 malam<br/><br/>
      </p>
    </Link>
  )
}

export default MobileAduhAddress;